// src/utils/bundleUtils.ts
import { Bundle, Language } from "@/types/types";
import { templateReplace } from "@/utils/stringUtils";
import { getTranslations } from "@/utils/translateServer";

function extractTranslationKey(friendlyName?: string | null): string | null {
  if (!friendlyName) return null;
  const match = friendlyName.match(/^(bundle_name_\w+)/);
  return match ? match[1] : null;
}

export async function formatBundleName(
  bundle: Bundle,
  language: Language,
  appendPrice = false,
  formattedPrice?: string,
): Promise<string> {
  const messages = await getTranslations(language);
  const { friendlyName, unlimited, dataAmount, duration } = bundle;

  const keyFromFriendlyName = extractTranslationKey(friendlyName);
  const fallbackKey = unlimited ? "bundle_name_unlimited" : "bundle_name_data";

  const key =
    keyFromFriendlyName && messages[keyFromFriendlyName]
      ? keyFromFriendlyName
      : fallbackKey;

  const data = unlimited
    ? messages["bundle_unlimited"]
    : dataAmount >= 1000
      ? dataAmount / 1000
      : dataAmount;

  const bundleName = templateReplace(messages[key], {
    data,
    days: duration,
  });

  return appendPrice && formattedPrice
    ? `${bundleName} - ${formattedPrice}`
    : bundleName;
}

export function formatSpeedString(
  speeds: string[] | undefined,
  fallback = "N/A",
): string {
  return Array.isArray(speeds) && speeds.length > 0
    ? speeds.join(", ")
    : fallback;
}
